import { Ability, AbilityBuilder } from '@casl/ability';

/**
 * Define as permissões do usuário baseado nos dados retornados pela API
 * @param {Array} permissions - Array de permissões do usuário no formato:
 * [{ recurso: 'produtos', acao: 'read', modulo: 'cadastros' }, ...]
 * @returns {Ability} - Instância do CASL Ability
 */
export function defineAbilityFor(permissions = []) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (permissions && permissions.length > 0) {
    permissions.forEach(permission => {
      if (permission.concedida !== false) {
        // Formato: can('acao', 'recurso')
        can(permission.acao, permission.recurso);
      } else {
        // Se concedida é explicitamente false (permissão especial negada)
        cannot(permission.acao, permission.recurso);
      }
    });
  }

  return build();
}

/**
 * Cria uma ability vazia (usuário sem permissões)
 */
export function createEmptyAbility() {
  return new Ability([]);
}

/**
 * Verifica se o usuário tem uma permissão específica
 * @param {Ability} ability - Instância do CASL Ability
 * @param {string} action - Ação a ser verificada (create, read, update, delete)
 * @param {string} subject - Recurso a ser verificado (produtos, usuarios, vendas, etc)
 * @returns {boolean}
 */
export function checkPermission(ability, action, subject) {
  return ability.can(action, subject);
}

export default defineAbilityFor;
